import React, { Dispatch, SetStateAction } from 'react';
import { Dropdown } from 'react-bootstrap';

import { StateLanguage } from '../../languages/config/StateLanguage';
import { legendInvalidIcon, legendValidInvalidIconRestart } from '../../tools/legend.data.entry.tool';
import { evaluateLegendValidRequiredIcon } from '../../scripts/validate.legend.script';
import { expressions } from '../../libraries/regular.expressions.library';
import { discountTypeList, discountTypeValue } from '../../libraries/discount.library';

import AppLegend from './Legend';

export interface AppInputDicountProps {
  discountType: {value: string, valid: boolean},
  discountValue: {value: string, valid: boolean},
  setDiscountType: Dispatch<SetStateAction<{value: string, valid: boolean}>>,
  setDiscountValue: Dispatch<SetStateAction<{value: string, valid: boolean}>>
};

const AppInputDicount: React.FunctionComponent<AppInputDicountProps> = ({discountType, discountValue, setDiscountType, setDiscountValue}) => {
  const {lang} = StateLanguage()

  const handleChangeDiscountType = (item: string) => {
    if (item !== discountType.value) {
      setDiscountType({value: item, valid: true})
      setDiscountValue({value: '', valid: (item === 'none')})
      legendValidInvalidIconRestart('input-discount', 'legend-discount-valid')
      legendValidInvalidIconRestart('input-discount', 'legend-discount-required')
    }
  }

  const handleChangeDiscountValue = (event: React.ChangeEvent <HTMLFormElement | HTMLInputElement>) => {
    setDiscountValue({...discountValue, value: event.target.value})
  }

  const validateDiscountValue = () => {
    switch (discountType.value) {
      case 'percentage':
        evaluateLegendValidRequiredIcon(expressions.percentage, discountValue, setDiscountValue, 'input-discount', 'legend-discount-valid', 'legend-discount-required')
        break;
      case 'fixed':
        evaluateLegendValidRequiredIcon(expressions.currency, discountValue, setDiscountValue, 'input-discount', 'legend-discount-valid', 'legend-discount-required')
        break;
      case 'none':
        setDiscountValue({...discountValue, valid: true})
        legendValidInvalidIconRestart('input-discount', 'legend-discount-valid')
        legendValidInvalidIconRestart('input-discount', 'legend-discount-required')
        break;
      default:
        setDiscountValue({...discountValue, valid: false})
        if (discountValue.value.length === 0) {
          legendInvalidIcon('input-discount', 'legend-discount-required')
        } else {
          legendInvalidIcon('input-discount', 'legend-discount-valid')
        }
        break;
    }
  }

  return (
    <>
      <div className="d-flex align-self-center">
        <div className="flex-shrink-0 me-3">
          <Dropdown>
            <Dropdown.Toggle variant="select2 select2-container select2-container--bootstrap5 select2-container--below select2-container--focus select2-container--open w-200px p-0">
              <span className="selection">
                <span className="select2-selection select2-selection--single form-select form-select-solid">
                  <span className="select2-selection__rendered" role="textbox">
                    {discountType.valid ? discountTypeValue(lang, discountType.value) : lang.labels.selectOption}
                  </span>
                </span>
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu variant="select2-container select2-container--bootstrap5 select2-container--open w-100">
              <span className="select2-dropdown select2-dropdown--below">
                <span className="select2-results">
                  <ul className="select2-results__options" role="listbox">
                    { discountTypeList(lang).map (( (item, index) => { return (
                      <li key={index} className={`select2-results__option select2-results__option--selectable ${item.code === discountType.value && "select2-results__option--selected"}`} role="option" aria-selected={item.code === discountType.value}>
                        <Dropdown.Item bsPrefix="select2-results__option__text" onClick={() => handleChangeDiscountType(item.code)}>{item.display}</Dropdown.Item>
                      </li>
                    )}))}
                  </ul>
                </span>
              </span>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="flex-grow-1">
          <input id="input-discount" className="form-control form-control-solid" type="text" autoComplete="off" name="discount" disabled={!(discountType.value === 'percentage' || discountType.value === 'fixed')} value={discountValue.value} onChange={handleChangeDiscountValue} onKeyUp={validateDiscountValue} onBlur={validateDiscountValue} />
        </div>
      </div>
      <AppLegend attribute={{check: discountValue.valid, name: "discount", index: null, sub_index: null}} container={{valid: true, required: true, identical: false, exists: false}}></AppLegend>
    </>
  )
}

export default AppInputDicount;
